import * as React from "react"
import {Box, Chip} from "@mui/material"

import { NotAllowedBlock } from "@components"


export default function buyboxColumn() {
	return {
		name: 'wonBuyBox', label: 'Won Buy Box?',
		options: {
			customBodyRowRenderLite: (value, row) => <Box sx={{ textAlign: 'center' }}>
				{!!value ? <Chip label={value} color={row.buyboxColor}/> : <NotAllowedBlock sx={{fontWeight: 'bold'}}/>}
			</Box>
		}
	}
}